import { render, staticRenderFns } from "./TasksForm.vue?vue&type=template&id=0dcacbde"
import script from "./TasksForm.vue?vue&type=script&lang=js"
export * from "./TasksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports